export default function ErrorMessage({error}){
    return <>{
        error && (
            <small className="text-danger form-text">
                {error?.message}
            </small>
        )
    }</>
}